import React from 'react';
import { Modal, Row } from 'antd';

import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';
import ThemedText from '@portal/components/ThemedText/ThemedText';

interface SimpleModalProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  title: string;
  description: string;
  onContinue?: () => void;
  buttonText?: string;
  titleAlign?: 'center' | 'start' | 'end';
  descriptionAlign?: 'center' | 'start' | 'end';
  loading?: boolean;
}

const SimpleModal = ({
  visible,
  setVisible,
  title,
  description,
  onContinue,
  buttonText = 'Continue',
  titleAlign = 'center',
  descriptionAlign = 'center',
  loading = false,
}: SimpleModalProps) => {
  return (
    <Modal
      open={visible}
      footer={null}
      title={null}
      className="simple-modal"
      closable
      onCancel={() => setVisible(false)}
      width={600}
      zIndex={50}
    >
      <div className="simple-modal__content">
        <ThemedText
          variant="h1"
          className={`simple-modal__title--${titleAlign}`}
        >
          {title}
        </ThemedText>
        <ThemedText
          variant="body"
          className={`simple-modal__description--${descriptionAlign}`}
        >
          {description}
        </ThemedText>
        <Row justify="center" className="simple-modal__button-container">
          <AdvancedButton
            text={buttonText}
            onClick={onContinue}
            loading={loading}
          />
        </Row>
      </div>
    </Modal>
  );
};

export default SimpleModal;
